







































































import { Component, Mixins, Prop } from "vue-property-decorator";
import { GlobalMixin } from "@/mixins/global";

@Component
export default class BenefitCard extends Mixins(GlobalMixin) {
  color: string = "";
  animation: string = "";

  @Prop({ type: Boolean, default: false }) haveTitle?: string;
  @Prop({ type: String, default: null }) imagePath?: string;
  @Prop({ type: String, default: null }) title?: string;
  @Prop({ type: Boolean, default: false }) align?: boolean;
  @Prop({ type: String, default: null }) content?: string;
  @Prop({ type: Boolean, default: false }) anticipated?: boolean;

  setAnimationIn(): void {
    this.color = "benefitCard";
    this.animation = "animate__animated animate__faster animate__slideInDown";
  }
  setAnimationOut(): void {
    this.color = "";
    this.animation = "animate__animated animate__faster animate__slideInUp";
  }
}
